import type { PropertyInterface } from './PropertyInterface'

export abstract class AbstractStringProperty implements PropertyInterface {
  abstract KEY: string

  constructor(private readonly value: string) {}

  getKey(): string {
    return this.KEY
  }

  getValue(): string {
    return this.value
  }
}
